export default __webpack_public_path__ + "media/images/features/saga/squids-ba167532a110771dd8b9b0b7e883e9e3.jpg";